module.exports = __webpack_public_path__ + "img/spgl2.c006431a.png";